import React, { useEffect, useRef, useState } from "react";
import Banners from "../banners/Banners";
import "../../assets/images/sprite-other-icons.svg";
import HomePopularGames from "../../popular games/HomePopularGames";
import casinoNgt from "../../assets/images/banners/casinonight-banner.png";
import {
  getAllGames,
  getSearchResults,
  setSearchInput,
} from "../crashGames/cl_CrashSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setReferralCode, setAffiliateCode } from "../signUp/cl_SignUpSlice";
import { LevelModal } from "../Loyalty/LevelModal";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import SlotGames from "../../slotGames/SlotGames";
import TopGamesList from "./TopGamesList/TopGamesList";
import ContentLoader from "./ContentLoader";
import HomeMain from "./cms_render_home";
import FooterBanner from "./FooterBanner";

const Home = () => {
  const [combinedgGames, setCombinedGames] = useState([]);
  const [homePopUp, setHomePopUp] = useState(false);
  const { searchInput, games, getAllgamesList } = useSelector(
    (state) => state?.crash
  );
  const { userDetails, userLoyalty } = useSelector((state) => state?.signIn);

  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const afid = searchParams.get("afid");
  const refid = searchParams.get("refid");
  const { isModalOpen } = useSelector((state) => state?.coinsHistory);
  if (afid) {
    dispatch(setAffiliateCode(afid));
  }
  if (refid) {
    dispatch(setReferralCode(refid));
  }

  const cid = searchParams.get("cid");
  const chid = searchParams.get("chid");
  useEffect(() => {
    if (afid) {
      localStorage.setItem("affiliateCodeData", JSON.stringify({ afid, cid, chid }))
    }
  }, [afid, cid, chid])

  useEffect(() => {
    const combinedData = getAllgamesList.reduce((acc, category) => {
      return acc.concat(category?.game);
    }, []);

    setCombinedGames(combinedData);
    dispatch(setSearchInput(""));
  }, [getAllgamesList]);

  useEffect(() => {
    dispatch(getSearchResults(combinedgGames, searchInput));
  }, [searchInput]);
  const token = getFromLocalStorage("gk");
  useEffect(() => {
    if (token) {
      setHomePopUp(true);
    }
  }, [token]);

  const lastLevel = getFromLocalStorage("lastLevel");

  useEffect(() => {
    dispatch(getAllGames());
  }, []);
  return (
    <div
      className="SB-page-content"
    >
      {userLoyalty?.level && userLoyalty.level !== lastLevel && <LevelModal />}
      {getAllgamesList?.length > 0 ? (
        <>
          <TopGamesList />
          <Banners />
          <HomePopularGames combinedgGames={combinedgGames} />
          <HomeMain />
          <FooterBanner />
        </>
      ) : (
        <ContentLoader />
      )}
    </div>
  );
};

export default Home;
